import { TabPermission } from 'src/app/core/interfaces/permissions';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';
import { Mobile } from '../../../mobile.setup';

const parent = Mobile.pages.groups;
const path = 'group-management';
const title = 'PAGE.MOBILE.GROUPS.GROUPS_MANAGEMENT.TITLE';

const res = [
  'createGroup',
  'actions',
  'actions.edit',
  'actions.delete',
  'actions.grantSubscription',
  'actions.grantSharedPlan',
];

export const MobileGroupsGroupManagementTab: TabPermission =
  PermissionsC.generateTabPermission(parent, path, title, res);
